export default "__VITE_ASSET__Bx9pJ87k__"